import React from 'react';
import { AlertBanner, SparkIcon, TooltipTrigger } from '@spark';

/**
 * Single insight row under a runtime control: a Spark AlertBanner whose text
 * carries an optional help icon with the longer explanation as a tooltip.
 */
export default function InsightNotice({ content, explanation, type = 'warning' }) {
  return (
    <AlertBanner
      className="configure-deployment-modal__insight"
      feedback={type}
      contentAlign="start"
      showButton={false}
      showCloseButton={false}
      text={
        <span className="configure-deployment-modal__insight-text">
          {content}
          {explanation ? (
            <TooltipTrigger text={explanation} placement="top">
              <span className="configure-deployment-modal__insight-help" tabIndex={0} aria-label="More information">
                <SparkIcon slug="circle-help" size="small" />
              </span>
            </TooltipTrigger>
          ) : null}
        </span>
      }
    />
  );
}
